
//	token 数据
const state = {
	testData: {},
}

//	同步
const mutations = {
	setTestDataSync(state, testData) {
		state.testData = testData;
	},

}

//	异步，外部保存数据调用此内部方法
const actions = {
	setTestData({
		commit
	}, testData) {
		commit("setTestDataSync", testData);
	},
}

//	获取
const getters = {
	getTestData(state) {
		return state.testData;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
